import { RichiestaModuloDTOPermessiItem } from '@framework/api-client';
import { useCurrentUser } from '@framework/auth';
import {
  IModuleStateMachineRecord,
  ModuleStateMachine,
  SubmissionLogic,
  getSubmissionDelegationRole,
} from '@framework/frontoffice-submission';
import React from 'react';
import { ModuleStateInfoBox } from './ModuleStateActionsWrapper';
import { BackToCompilationButton } from './action-buttons/BackToCompilationButton';
import { FinishCompilingButton } from './action-buttons/FinishCompilingButton';
import { ReadyToSignButton } from './action-buttons/ReadyToSignButton';
import { SignActionButtons } from './action-buttons/SignActionButtons';
import { SignToCompilationButton } from './action-buttons/SignToCompilationButton';

export interface IModuleStateBottomBoxProps {
  data: IModuleStateMachineRecord;
}

export function ModuleStateBottomBox(props: IModuleStateBottomBoxProps) {
  const { data } = props;
  const user = useCurrentUser();

  // Controllo se la compilazione del modulo può essere completata automaticamente
  // o richiede l'intervento manuale dell'utente.
  const isAutoComplete = ModuleStateMachine.can(data, '.autoComplete', user);

  // Se è possibile completare automaticamente il modulo, non mostro nessun pulsante
  if (isAutoComplete.allowed) {
    return null;
  }

  if (SubmissionLogic.isSubmissionSent(data.submission)) {
    return null;
  }

  if (
    data.module?.permessi?.every(
      p => p === RichiestaModuloDTOPermessiItem.VISUALIZZAZIONE,
    ) &&
    getSubmissionDelegationRole(data.delegationData, user) === 'delegate'
  ) {
    return null;
  }

  return (
    <ModuleStateInfoBox module={props.data.module}>
      {/* <ModuleStateSummary {...props} /> */}
      <ReadyToSignButton {...props} />
      <FinishCompilingButton {...props} />
      <SignActionButtons {...props} />
      {/* <SignCompletedAction {...props} /> */}
      <BackToCompilationButton {...props} />
      <SignToCompilationButton {...props} />
    </ModuleStateInfoBox>
  );
}
